import React from 'react';
import './DateRangePicker.css';

function DateRangePicker({ startDate, endDate, onStartDateChange, onEndDateChange, disabled }) {
  return (
    <div className="date-range-picker">
      <div className="date-input-group">
        <label htmlFor="startDate">Start Date</label>
        <input
          type="date"
          id="startDate"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          disabled={disabled}
        />
      </div>
      <div className="date-input-group">
        <label htmlFor="endDate">End Date</label>
        <input
          type="date"
          id="endDate"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default DateRangePicker;
